import React, { Component } from "react";
import { connect } from "react-redux";
import { setPymeValue } from "../../../actions";
import { pyme } from "../../../operations";
import Continue from "../../Common/Continue";
import Loader from '../../Common/Loader';
import Text from '../../Common/Form/Text';

class CoveragePlans extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
    };

    this.continueCondition = this.continueCondition.bind(this);
    this.getPlans = this.getPlans.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentDidMount() {
    const { getCoveragePlans } = this.props;
    this.checkContinueState(null);
    getCoveragePlans();
  }
  
  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {
    const { coveragePlans, coveragePlan } = this.props;
    return ( 
      coveragePlans != null &&
      coveragePlans.length > 0 &&
      coveragePlan
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  handleOnClick(key) {
    const { onValueChange } = this.props;
    return () => onValueChange('coveragePlan', key);
   }

  getPlans() {
    const { coveragePlan, coveragePlans } = this.props;
    const plans = coveragePlans.map((e)=> {
      const splitPoint = e.valor.indexOf(" USD ");
      const plan = {
        key: e.clave,
        title: e.valor.slice(0, splitPoint),
        amount: e.valor.slice(splitPoint+1, e.valor.length),
        selected: e.clave == coveragePlan,
        onChange: this.handleOnClick(e.clave),
      };
      return (<CoveragePlan key={plan.key} {...plan} />)
    })
    return (<div className="coverage-plans">{plans}</div>);
  }

  render() {
    const { continue: toContinue } = this.state;
    const { 
      innerLoading,
      coveragePlans
    } = this.props;
    return (
      <div>
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          ¿Cuál entendes que sería tu pérdida económica en caso de sufrir robo o rapiña en tu empresa?
        </Text>
        {innerLoading ? <Loader message='' /> :
        <div>
          { coveragePlans != null &&
            coveragePlans.length > 1 && 
            this.getPlans() }
          <Continue state={toContinue} />
        </div>}
      </div>
    );
  }
}

const CoveragePlan = ({  title, amount, selected, onChange }) => {
  const selectedClass = selected? "coverage-plan-selected": "";
  return (
  <div className={`coverage-plan ${selectedClass}`} onClick={onChange}>
    <div className="coverage-plan-title">{title}</div>
    <div className="coverage-plan-amount">{amount}</div>
    <div className="coverage-plan-desc">Cobertura de Rapiña y/o Hurto Contenido General</div>
  </div>
)};

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,
    innerLoading: state.steps.isInnerLoading,

    coveragePlan: state.pyme.coveragePlan,
    coveragePlans: state.pyme.coveragePlans,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCoveragePlans: () => {
      dispatch(pyme.getCoveragePlans());
    },
    onValueChange: (type, value) => {
      dispatch(setPymeValue(type, value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CoveragePlans);